"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function CreditCardIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M20.052,4.8H3.947A2.8,2.8,0,0,0,1.08,7.52v9.8a2.8,2.8,0,0,0,2.867,2.718H20.052A2.8,2.8,0,0,0,22.92,17.32V7.52A2.8,2.8,0,0,0,20.052,4.8ZM5.24,17.141H3.73a.824.824,0,1,1,0-1.648H5.24a.824.824,0,1,1,0,1.648Zm1.96-6.7a.823.823,0,0,1-.823.824H3.73a.824.824,0,0,1-.824-.824V8.684a.823.823,0,0,1,.824-.823H6.377a.822.822,0,0,1,.823.823Zm3.05,6.7H8.74a.824.824,0,1,1,0-1.648h1.51a.824.824,0,1,1,0,1.648Zm5.01,0H13.75a.824.824,0,1,1,0-1.648h1.51a.824.824,0,1,1,0,1.648Zm5.01,0H18.76a.824.824,0,1,1,0-1.648h1.51a.824.824,0,1,1,0,1.648Z" })));
}
exports.default = CreditCardIcon;
